import { Utils } from '../../common';
import RegisterApi from '../api/RegisterApi';
import { existy } from '../../modules/shared/functional';

export function createAccount() {
  return {
    type: 'CREATE_ACCOUNT',
  };
}

export function creatingAccount() {
  return {
    type: 'CREATING_ACCOUNT',
  };
}

export function forgotPassword() {
  return {
    type: 'FORGOT_PASSWORD',
  };
}

export function onTextChanged(name, value) {
  return {
    type: 'TEXT_CHANGED',
    name,
    value,
  };
}

export function registrationSuccess() {
  return {
    type: 'REGISTRATION_SUCCESS',
  };
}

export function registrationFailure(value) {
  return {
    type: 'REGISTRATION_FAILURE',
    value,
  };
}

function ObjectException(value) {
  this.value = value;
}

export function register(values, onRegistrationSuccess) {
  return (dispatch, getState) => {
    dispatch(creatingAccount());
    RegisterApi.register(values)
      .then((response) => {
        const resp = response.data;
        if (resp.error) {
          dispatch(registrationFailure(resp.error));
          throw new ObjectException(JSON.parse(resp.error));
        }

        const state = getState();

        if (existy(state.modal.event)) {
          const loginCompletedEvent =
          new CustomEvent('loginCompleted', { detail: state.modal.event.detail });
          document.dispatchEvent(loginCompletedEvent);

          const loginStatusChangeEvent =
          new CustomEvent('loginStatusChange', { detail: { taskName: 'loginStatusChange', isLoggedIn: true } });
          document.dispatchEvent(loginStatusChangeEvent);
        }

        window.digitalData.user.profile.authenticationStatus = 'consumer';

        const thdAnalyticsEvent = {
          category: {
            primaryCategory: 'button submission',
          },
          eventInfo: {
            eventName: 'registration',
          },
        };

        Utils.sendAnalyticsEvent(thdAnalyticsEvent).then(() => {
          onRegistrationSuccess(dispatch);
        });
      })
      .catch((exception) => {
        dispatch(registrationFailure(exception.value.error));
      });
  };
}

export function validateUniqueEmail() {
  return {
    type: 'VALIDATE_UNIQUE_EMAIL',
  };
}
